(function () {
  var SECTION_SELECTOR = '[data-smart-featured-collection]';

  function refreshReviews() {
    window.requestAnimationFrame(function () {
      if (window.AirReviews && typeof window.AirReviews.init === 'function') {
        window.AirReviews.init();
      }
      if (window.AirReviews && typeof window.AirReviews.refresh === 'function') {
        window.AirReviews.refresh();
      }
      if (window.AirReviewsWidget && typeof window.AirReviewsWidget.init === 'function') {
        window.AirReviewsWidget.init();
      }
    });
  }

  function updateControls(track, previousButton, nextButton) {
    if (!track || !previousButton || !nextButton) return;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    previousButton.disabled = track.scrollLeft <= 2;
    nextButton.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function getScrollStep(track) {
    var firstCard = track.querySelector('.smart-product-card');
    if (!firstCard) return track.clientWidth;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0);
    return firstCard.getBoundingClientRect().width + gap;
  }

  function initSection(root) {
    if (!root) return;
    var section = root.matches && root.matches(SECTION_SELECTOR) ? root : root.querySelector(SECTION_SELECTOR);
    if (!section || section.getAttribute('data-smart-featured-initialized') === 'true') return;
    section.setAttribute('data-smart-featured-initialized', 'true');
    refreshReviews();

    var track = section.querySelector('[data-smart-featured-track]');
    var previousButton = section.querySelector('[data-smart-featured-prev]');
    var nextButton = section.querySelector('[data-smart-featured-next]');
    if (!track || !previousButton || !nextButton) return;

    previousButton.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollStep(track), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function () {
      track.scrollBy({ left: getScrollStep(track), behavior: 'smooth' });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var direction = event.key === 'ArrowLeft' ? -1 : 1;
      track.scrollBy({ left: getScrollStep(track) * direction, behavior: 'smooth' });
    });

    var updateScheduled = false;
    track.addEventListener('scroll', function () {
      if (updateScheduled) return;
      updateScheduled = true;
      window.requestAnimationFrame(function () {
        updateControls(track, previousButton, nextButton);
        updateScheduled = false;
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function () {
        updateControls(track, previousButton, nextButton);
      });
      resizeObserver.observe(track);
    }

    window.requestAnimationFrame(function () {
      updateControls(track, previousButton, nextButton);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
